import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, LoadingOverlay } from "@mantine/core";
import ResellerCustomersWrapper from "src/features/resellerCustomers/ResellerCustomersWrapper";
const ResellerCustomersContainer = ({ isLoading }) => {
    return (_jsxs(Box, { pos: "relative", display: "flex", flex: "1", children: [_jsx(LoadingOverlay, { visible: isLoading }), !isLoading && _jsx(ResellerCustomersWrapper, {})] }));
};
export default ResellerCustomersContainer;
